import React, { useState } from 'react';
import { CountrySettings } from './CountrySettings';
import Loading from '../Loading';
import { observer } from 'mobx-react-lite';
import { action, observable, makeAutoObservable } from 'mobx';
import { AppState, useAppStateContext } from 'src/AppState/AppState';
import { CountriesList } from 'src/components/CountriesList/CountriesList';
import { SingleCountrySettingsType } from 'src/api/config/admin/getCountries';
import { apiCommon } from 'src/api/ApiCommon';
import {
    AdminCountriesContent,
    AdminCountriesContentLhs,
    AdminCountriesContentWrapper,
} from 'src/components/AdminCountryDefaults/AdminCountryDefaults.style';

export class AdminCountryDefaultsState {
    @observable public selectedCountry: SingleCountrySettingsType | null = null;
    @observable public isLoading: boolean = false;

    public constructor(private readonly appState: AppState) {
        makeAutoObservable(this);
    }

    @action public onChangeCountrySettings = async (
        id: string,
        name: string,
        service: string,
        checked: boolean
    ): Promise<void> => {
        this.isLoading = true;
        if (this.selectedCountry !== null) {
            const country = {
                id,
                name,
                services: {
                    ...this.selectedCountry.services,
                    [service]: checked,
                },
            };
            await apiCommon.adminUpdateCountry.run(country);
            await this.appState.countriesState.countries.refresh();
            this.selectedCountry = country;
        }
        this.isLoading = false;
    };

    @action public onSelectCountry = (country: SingleCountrySettingsType): void => {
        this.selectedCountry = country;
    };
}

export const AdminCountryDefaultsNew = observer(() => {
    const appState = useAppStateContext();
    const [state] = useState(() => new AdminCountryDefaultsState(appState));

    const countries = appState.countriesState.countries.get();

    if (countries.type !== 'ready') {
        return null;
    }

    return (
        <AdminCountriesContentWrapper>
            <AdminCountriesContentLhs>
                <CountriesList
                    onCountrySelect={state.onSelectCountry}
                    countries={countries.value}
                />
            </AdminCountriesContentLhs>

            <AdminCountriesContent>
                {state.selectedCountry === null ? null : (
                    <CountrySettings
                        settings={state.selectedCountry}
                        onCountryClick={state.onChangeCountrySettings}
                    />
                )}
            </AdminCountriesContent>
            <Loading active={state.isLoading} />
        </AdminCountriesContentWrapper>
    );
});
